/**
 * The Valdon mark.
 *
 * Two variants, and which one is correct depends entirely on what is behind it:
 *
 *   blue   -> light surfaces (landing, login, reports)
 *   white  -> dark surfaces (the navy sidebar)
 *
 * Both are the same artwork with the background removed, so they can never
 * drift apart. Getting this wrong is not subtle — a white mark on a white page
 * is simply invisible.
 */
export default function Logo({ variant = 'blue', className = '', height, alt = 'Valdon Site Control 360' }) {
  const src = variant === 'white' ? '/logo-white.png' : '/logo-blue.png';
  const size = height ?? (variant === 'white' ? 64 : 44);

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      // Inline, not the height attribute: .brand-logo sets height in CSS, and
      // a CSS rule beats the attribute, so an explicit height passed here was
      // silently ignored and every logo rendered at the stylesheet's size.
      //
      // Expressed as a custom property rather than `height` directly, so that
      // state-driven sizes in the stylesheet — .sidebar.collapsed .brand-logo
      // at 26px — still win over the default without an inline override.
      style={{ '--logo-height': `${size}px`, width: 'auto', objectFit: 'contain' }}
    />
  );
}